import { useEffect } from "react";

/**
 * Custom hook to remove network listeners once the app is ready.
 * @param isLoading Boolean indicating if the app is fully loaded.
 */
export const useRemoveNetworkListeners = (isLoading: boolean | undefined) => {
  useEffect(() => {

    if (!!isLoading && typeof window.removeNetworkListeners === "function") {
      window.removeNetworkListeners(); // Removes network listeners when the app is ready
    }
  }, [isLoading]);
};
